import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "m15.379 19.14-3.271-6.54 7.359-7.359-4.088 13.9ZM4.86 8.621l13.9-4.087-7.359 7.358-6.541-3.27Zm-1.501-.6a.5.5 0 0 0-.083.927l7.852 3.925 3.925 7.851a.5.5 0 0 0 .927-.083l5-17a.5.5 0 0 0-.621-.62l-17 5Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }